import React from 'react'
import { Route, Switch } from 'react-router-dom'

import NavigationExportsList from './NavigationExportsList'

export default () => {
    return {
        routes: [
            {
                path: '/navigation-export',
                render: ({ match }) => (
                    <Switch>
                        <Route path={`${match.url}`} exact component={NavigationExportsList} />
                    </Switch>
                ),
            },
        ],
    }
}
